/* eslint-disable no-magic-numbers */

export type SkillSetNumber = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
export type SkillSetGameNumber = 1 | 2 | 3;

/**
 * Returns metadata describing each of the 8 skill sets and their 3 games,
 * including the slug used to look up progress data (e.g. `ss_1_1`).
 */
export function getSkillSetsMeta() {
  return skillSetsMeta;
}

const skillSetsMeta = [
  buildSSSetMetaData(1),
  buildSSSetMetaData(2),
  buildSSSetMetaData(3),
  buildSSSetMetaData(4),
  buildSSSetMetaData(5),
  buildSSSetMetaData(6),
  buildSSSetMetaData(7),
  buildSSSetMetaData(8),
] as const;

function buildSSSetMetaData<S extends SkillSetNumber>(setNumber: S) {
  return {
    label: `Skill Set ${setNumber}`,
    setNumber,
    games: [
      buildSSGameMeta(setNumber, 1),
      buildSSGameMeta(setNumber, 2),
      buildSSGameMeta(setNumber, 3),
    ],
  } as const;
}

function buildSSGameMeta<
  S extends SkillSetNumber,
  G extends SkillSetGameNumber,
>(setNumber: S, gameNumber: G) {
  return {
    gameNumber,
    slug: `ss_${setNumber}_${gameNumber}` as const,
  };
}
